export { default } from './RegistrationPreview'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPreview/index.js